export default __webpack_public_path__ + "static/media/RightBot.ad12f813.png";